export function GoogleAd() { return null; }
export function GoogleFeedAd() { return null; }
